<template>
  <TemplateConMenuLateral>
    <Banner slot="banner" :titulo="cliente.nombre" style="flex: 1 0 100%;" />

    <div slot="menu" class="menucontextual">
      <ul>
        <li>
          <a href="#" class="link" @click.prevent="cambiarTelefono(true)">Cambiar teléfono</a>
        </li>
        <li>
          <a href="#" class="link" @click.prevent="cambiarEmail(true)">Cambiar e-mail</a>
        </li>
        <li>
          <a href="#" class="link" @click.prevent="cambiarPassword(true)">Cambiar contraseña</a>
        </li>
        <li>
          <a href="#" class="link" @click.prevent="cambiarGdpr(true)">Cambiar Protección Datos</a>
        </li>
      </ul>
    </div>

    <div slot="contenido" class="tarjetario">
      <DatosCliente :cliente="cliente" />
      <CambiarTelefono v-if="popUpCambiarTelefono" @close="cambiarTelefono(false)" />
      <CambiarEmail v-if="popUpCambiarEmail" @close="cambiarEmail(false)" />
      <CambiarPassword v-if="popUpCambiarPassword" :cliente="cliente" @close="cambiarPassword(false)" />
      <CambiarGdpr v-if="popUpCambiarGdpr" :cliente="cliente" @close="cambiarGdpr(false)" />
    </div>
  </TemplateConMenuLateral>
</template>

<script>
export default {
  data() {
    return {
      popUpCambiarTelefono: false,
      popUpCambiarEmail: false,
      popUpCambiarPassword: false,
      popUpCambiarGdpr: false
    };
  },

  computed: {
    cliente() {
      return this.$store.state.portfolio.cliente;
    }
  },

  mounted() {
    this.$store.dispatch("getDatosCliente");
  },

  methods: {
    cambiarTelefono(val) {
      console.log("cambiarTelefono:" + val);
      this.popUpCambiarTelefono = val;
      this.popUpCambiarEmail = false;
      this.popUpCambiarPassword = false;
      this.popUpCambiarPassword = false;
    },
    cambiarEmail(val) {
      this.popUpCambiarEmail = val;
      this.popUpCambiarPassword = false;
      this.popUpCambiarTelefono = false;
      this.popUpCambiarGdpr = false;
    },

    cambiarPassword(val) {
      console.log("cambiarPassword:" + val);
      this.popUpCambiarPassword = val;
      this.popUpCambiarTelefono = false;
      this.popUpCambiarEmail = false;
      this.popUpCambiarGdpr = false;
    },

    cambiarGdpr(val) {
      this.popUpCambiarPassword = false;
      this.popUpCambiarTelefono = false;
      this.popUpCambiarEmail = false;
      this.popUpCambiarGdpr = val;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../Menus/menus.scss";
</style>
